export default __webpack_public_path__ + "static/media/ui.8975287f.svg";